export enum ParkerRegistrationDataType {
  Raw,
  Evaluated
}
